import { SportType } from '../../../models/court/dto/court.dto';

/**
 * Game-format variants, not venue sports. An event's sportType is what mobile
 * filters the "Rejoindre" feed by, so offering these would let an admin create
 * an event under a format no player can ever filter to.
 */
const GAME_FORMAT_VARIANTS: SportType[] = [
    SportType.PADEL1V1,
    SportType.BASKETBALL1V1,
];

/**
 * Sport choices for the event form, derived from the enum rather than
 * hand-listed. The previous hardcoded list was missing sports the API supports
 * (Fitness — MYS-122, Mooving) and offered "Soccer", which is not a SportType
 * value at all, so picking it wrote a sport the API enum does not recognise.
 *
 * Padel leads because it is the form default and by far the most common across
 * tenants; everything else stays alphabetical so the list is predictable as the
 * enum grows.
 *
 * `currentValue` keeps an event editable when its stored sport is not offered —
 * legacy "Soccer" rows, or a value later retired from the list. Without it the
 * Chakra <select> finds no matching <option>, renders blank on a required
 * field, and silently re-persists the old value on save.
 */
export const buildSportOptions = (
    currentValue?: string | null,
): { label: string; value: string }[] => {
    const offered: SportType[] = [
        SportType.PADEL,
        ...Object.values(SportType)
            .filter(
                (sport) =>
                    sport !== SportType.PADEL && !GAME_FORMAT_VARIANTS.includes(sport),
            )
            .sort((a, b) => a.localeCompare(b)),
    ];

    const options = offered.map((sport) => ({ label: sport, value: sport as string }));

    if (currentValue && !offered.some((sport) => sport === currentValue)) {
        return [...options, { label: currentValue, value: currentValue }];
    }
    return options;
};
